import { useState, useRef,useEffect } from "react"
import { useUser } from "@/contexts/UserContext";

export default function TextArea(props) {
    const inputRef = useRef(null)
    const [canEdit, setCanEdit] = useState(false)
    const {user} = useUser()

    useEffect(() => {
        setCanEdit(user.role >= 10)
    }, [user])

    const handleSize = ()=>{
        if(inputRef.current){
            inputRef.current.style.height = 'auto';
            inputRef.current.style.height = inputRef.current.scrollHeight + 'px';
        }
    }

    const handleSelect = (e) =>{
        if(!props.onSelect) return;
        const textarea = e.target
        const start = textarea.selectionStart
        const end = textarea.selectionEnd
        
        props.onSelect(textarea.value.substring(start, end))
    }

    const handleClick = () =>{
        if(props.onSelect){
            props.onSelect('click')
        }
    }

    useEffect(() => {
        handleSize();
    }, [props.value])

    useEffect(() => {
        const textarea = inputRef.current;
        if (!textarea) return;
    
        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                handleSize();
            }
        });
    
        resizeObserver.observe(textarea);
    
        return () => resizeObserver.disconnect();
    }, []);

    if(!canEdit && !props.value) return null

    return (
        <textarea 
            ref={inputRef}
            value={props.value}
            placeholder={props.placeholder}
            onChange={props.onChange} 
            onSelect={handleSelect}
            onMouseUp={handleSelect}
            //onClick={handleClick}
            readOnly={!canEdit}
            className={`placeholder:text-secondary-foreground/30 placeholder:italic ${props.className}`} rows={1} 
        />
    )
}